import { render, staticRenderFns } from "./CompanyNotice.vue?vue&type=template&id=6c409e4e&"
var script = {}
import style0 from "./CompanyNotice.vue?vue&type=style&index=0&id=6c409e4e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports